module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship5.b8a5b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship5.png
// module id = iGAu
// module chunks = 0